module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_32.c3bd197d.mp3";